import { Account, AccountPermission, Listing } from '@app/models'

import { ChatState } from './types'

export const CONVERSATIONS_LIST_SIZE = 30
export const MESSAGES_LIST_SIZE = 30

export const REMINDER_CAMPAIGN = 'unreplied_conversation_reminder'
export const REMINDER_CONTENT = 'cta_reply'

export const initialChatState: ChatState = {
  acsChatParticipantId: '',
  acsChatToken: { token: '', expiresOn: '' },
  participantIds: [],

  conversations: {},
  nextPageCursor: '0',
  allConversationsLoaded: false,
  unreadList: [],
  unreadTotal: 0,

  listings: new Map<number, Listing>([]),
  permissions: new Map<number, AccountPermission>([]),
  accounts: new Map<number, Account>([]),
  fetching: 'IDLE',
  fetchingListChunk: 'IDLE',
  fetchInitialStateErrorStatus: undefined,

  status: 'dispatched',
  replyDetectionStatus: undefined,
  hasSpam: false,
}
